<template>
  <v-container class="bordered bg-white">
    <v-row>
      <v-col>
        <DataTable
          :headers="headers"
          :items="machines" />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-table class="bottom_table">
          <tbody>
            <tr>
              <td class="wide_col">
                {{
                  $t(
                    "entities.manufacturingStep.fields.work_system_costs_manufacturing_step_part"
                  )
                }}
              </td>
              <td class="input_col">
                <CalcOutput
                  :id="nodeId"
                  field="work_system_costs_manufacturing_step_part"
                  hide-label />
              </td>
              <td class="e_per_piece_col">
                {{ $t("units.e_per_piece_long") }}
              </td>
              <td>&nbsp;</td>
            </tr>
          </tbody>
        </v-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useTranslation } from "i18next-vue";
import { useSpaceStore } from "../../../../stores/spaceStore";
import CalcOutput from "../../../../components/Elements/CalcOutput.vue";

import DataTable from "@/components/Elements/DataTable.vue";

const spaceStore = useSpaceStore();

const { t } = useTranslation();
const step = ref(null);
// const work_system_costs_manufacturing_step_part = ref(16);

const props = defineProps({
  nodeId: {
    type: String,
    required: true
  }
});

const part = computed(() => {
  return spaceStore.getElement(props.nodeId);
});

const machines = computed(() => {
  return spaceStore.getElementList(props.nodeId, "machine").map((value) => ({
    ...value,
    cycle_time_part: part.value.cycle_time_part,
    share_of_the_lot_percentage_part:
      part.value.share_of_the_lot_percentage_part,
    number_of_parts_part: part.value.number_of_parts_part,
    work_system_costs_machine_part:
      ((part.value.cycle_time_part / 3600) *
        (part.value.share_of_the_lot_percentage_part / 100) *
        value.machine_hourly_rate_machine) /
      part.value.number_of_parts_part
  }));
});

onMounted(() => {
  step.value = spaceStore.calculationElements[props.nodeId];
});

const headers = computed(() => [
  {
    title: t("entities.manufacturingStep.fields.producer_machine"),
    sortable: false,
    key: "manufacturer_machine"
  },
  {
    title: t("entities.manufacturingStep.fields.category_machine"),
    key: "category_machine",
    sortable: false
  },
  {
    title: t("entities.manufacturingStep.fields.type_machine"),
    key: "type_machine",
    sortable: false
  },
  {
    title: t("entities.manufacturingStep.fields.machine_hourly_rate_machine"),
    key: "machine_hourly_rate_machine",
    sortable: true
  },
  {
    title: t("entities.part.fields.cycle_time_part"),
    key: "cycle_time_part",
    sortable: true
  },
  {
    title: t("entities.part.fields.number_of_parts_part"),
    key: "number_of_parts_part",
    sortable: true
  },
  {
    title: t("entities.part.fields.share_of_the_lot_percentage_part"),
    key: "share_of_the_lot_percentage_part",
    sortable: true
  },
  {
    title: t(
      "entities.manufacturingStep.fields.work_system_costs_machine_part"
    ),
    key: "work_system_costs_machine_part",
    sortable: true
  }
]);
</script>

<style scoped lang="scss">
:deep() .v-data-table-header__content {
  font-weight: 700;
  font-size: smaller;
}

:deep()
  .border-table
  .v-table__wrapper
  > table
  > thead
  > tr
  > th:not(:last-child) {
  border-right: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}

:deep()
  .border-table
  .v-table__wrapper
  > table
  > tbody
  > tr
  > td:not(:last-child),
.border-table .v-table__wrapper > table > tbody > tr > th:not(:last-child) {
  border-right: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}

.bottom_table {
  font-size: 85%;

  .wide_col {
    width: 180px;
  }

  .input_col {
    //width: 80px;
    padding: 0 6px !important;

    .v-field__input {
      min-height: 10px !important;
    }
  }

  .e_per_piece_col {
    width: 30px;
    padding: 0 6px !important;
    white-space: nowrap;
  }

  td,
  th {
    border-bottom: none !important;
  }

  .low-height {
    td,
    th {
      height: 40px !important;
    }
  }

  .v-field__input {
    padding: 4px 8px !important;
  }
}
</style>
